import React from 'react';
import { User, Shield, BarChart3 } from 'lucide-react';
import { ThemeContext } from '../pages/theme';

const ViewTypeSwitcher = ({ viewType: propViewType, onSelect, hasAdminLevel, role }) => {
  const { theme } = React.useContext(ThemeContext);
  const [view, setView] = React.useState(() => propViewType || localStorage.getItem('viewType') || 'user');

  React.useEffect(() => {
    // Listen for viewType changes (e.g., from login or other tabs)
    const syncViewType = () => {
      setView(propViewType || localStorage.getItem('viewType') || 'user');
    };
    window.addEventListener('managerViewTypeChanged', syncViewType);
    window.addEventListener('storage', syncViewType);
    return () => {
      window.removeEventListener('managerViewTypeChanged', syncViewType);
      window.removeEventListener('storage', syncViewType);
    };
  }, [propViewType]);

  const doSelect = (type) => {
    if (type === view) return;
    try {
      localStorage.setItem('managerViewType', type);
      localStorage.setItem('viewType', type);
      window.dispatchEvent(new Event('managerViewTypeChanged'));
    } catch (e) {
      console.warn('Failed to write managerViewType/viewType to localStorage', e);
    }
    setView(type);
    if (typeof onSelect === 'function') onSelect(type);
  };

  const showAdmin = (() => {
    try {
      if (role === 'admin') return true;
      if (typeof hasAdminLevel === 'function') return hasAdminLevel();
      return false;
    } catch (e) { return false; }
  })();

  const showManager = (() => {
    try {
      return role === 'manager';
    } catch (e) { return false; }
  })();

  const baseStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    padding: '8px 12px',
    borderRadius: '9999px',
    border: 'none',
    background: 'transparent',
    color: theme === 'light' ? '#64748b' : 'rgba(255,255,255,0.6)',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontSize: '12px',
    fontWeight: 600,
  };

  const activeStyle = {
    background: 'linear-gradient(135deg, #2e7cba 0%, #1e5a96 100%)',
    color: '#ffffff',
    transform: 'scale(1.02)'
  };

  return (
    <div style={{ display: 'flex', gap: 4, borderRadius: '9999px', padding: 6 }}>
      <button
        type="button"
        onClick={() => doSelect('user')}
          disabled={view === 'user'} // ✅ منع الضغط
        style={{ ...baseStyle, ...(view === 'user' ? activeStyle : {}) }}
        title="User View"
      >
        <User size={14} />
        {view === 'user' && 'User'}
      </button>

      {showManager && (
        <button
          type="button"
          onClick={() => doSelect('manager')}
          style={{ ...baseStyle, ...(view === 'manager' ? activeStyle : {}) }}
          title="Manager View"
        >
          <BarChart3 size={14} />
          {view === 'manager' && 'Manager'}
        </button>
      )}

      {showAdmin && (
        <button
          type="button"
          onClick={() => doSelect('admin')}
          style={{ ...baseStyle, ...(view === 'admin' ? activeStyle : {}) }}
          title="Admin View"
        >
          <Shield size={14} />
          {view === 'admin' && 'Admin'}
        </button>
      )}
    </div>
  );
};

export default ViewTypeSwitcher;
